
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { LanguageVariableModel } from './Language.Api.Models.LanguageVariable';
import { Model, ModelProperty } from 'models/Model';


export class LanguageModel extends Model<LanguageModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'isoCode', type: 'string' },
		{ name: 'name', type: 'string' },
		{ name: 'languageVariables', type: 'LanguageVariableModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new LanguageVariableModel }, properties: () => { return LanguageVariableModel.classProperties } }
	];
	[key: string]: any;
	
	public isoCode: string;
	public name: string;
	public languageVariables: LanguageVariableModel[];
    
	constructor(){
		super();
		this.isoCode = '';
		this.name = '';
		this.languageVariables = [];
		
	}
	getProperties(){
		return LanguageModel.classProperties;
	}
}

